// extracted by mini-css-extract-plugin
export var divider = "_i2-7";
export var itemsToggle = "_i2-8";
export var mergeModal = "_i2-1";
export var optionCard = "_i2-4";
export var radioGroup = "_i2-6";
export var radioOption = "_i2-0";
export var selected = "_i2-5";
export var shipmentOptions = "_i2-2";
export var tableOptions = "_i2-3";